import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=a8fad038&scoped=true&"
import script from "./Messages.vue?vue&type=script&lang=ts&"
export * from "./Messages.vue?vue&type=script&lang=ts&"
import style0 from "./Messages.vue?vue&type=style&index=0&id=a8fad038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fad038",
  null
  
)

export default component.exports